import script from "./course-layout-v3.vue?vue&type=script&setup=true&lang=js"
export * from "./course-layout-v3.vue?vue&type=script&setup=true&lang=js"

import "./course-layout-v3.vue?vue&type=style&index=0&id=31df2915&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31df2915"]])

export default __exports__